import gql from 'graphql-tag';

const SimpleDegreeFragment = gql`
  fragment SimpleDegreeFragment on DegreesV1 {
    slug
    id
  }
`;

const SimpleMastertrackFragment = gql`
  fragment SimpleMastertrackFragment on CatalogMastertracksV1 {
    slug
    id
  }
`;

export const LookupDegreeViaSlugQuery = gql`
  query getDegreesDataForSave($degreeSlug: String!) {
    DegreesV1Resource {
      bySlug(slug: $degreeSlug) {
        elements {
          ...SimpleDegreeFragment
        }
      }
    }
  }
  ${SimpleDegreeFragment}
`;

export const LookupMastertrackViaSlugQuery = gql`
  query getMastertrackData($mastertrackSlug: String!) {
    CatalogMastertracksV1Resource {
      bySlug(slug: $mastertrackSlug) {
        elements {
          ...SimpleMastertrackFragment
        }
      }
    }
  }
  ${SimpleMastertrackFragment}
`;
